import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ParticipantView from './ParticipantView';
import { useMeeting } from "@videosdk.live/react-sdk";
import Controls from './Controls';
import WaitingToJoinScreen from './WaitingToJoinScreen';
import toast from 'react-hot-toast';
import ReactPaginate from 'react-paginate';
import PresenterView from './PresenterView';
import ParticipantViewScreenShare from './ParticipantViewScreenShare';
import AudioParticipantView from './AudioParticipantView';
const MeetingView = (props) => {
    const [joined, setJoined] = useState(null);


    const navigate = useNavigate();

    const { join, leave, participants, end, presenterId } = useMeeting({
        onMeetingJoined: () => {
            setJoined("JOINED");
            localStorage.setItem('meetingStarted', 'joined')
        },
        onMeetingLeft: () => {
            props.onMeetingLeave();
        },
        onParticipantJoined: (participant) => {

            if (props.user_type === "tutor") {
                toast.success(`${participant.displayName} has joined the meeting`);

            }

            if (participant?.metaData?.user_type === "tutor" && props.user_type === "student") {
                toast.success(`Tutor ${participant.displayName} has joined the meeting`);
            }
        },
    });

    const joinMeeting = () => {
        setJoined("JOINING");
        join();
    };

    // useEffect(() => {
    //     setJoined("JOINING");
    //     join();
    // }, [])

    useEffect(() => {
        // Disable Back and Forward buttons
        const handlePopState = (event) => {
            event.preventDefault();
            navigate(window.location.pathname); // Redirect to the current path
        };

        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', handlePopState);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    useEffect(() => {
        // Disable Refresh
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ''; // Required for modern browsers
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);



    const participantsArray = [...participants.entries()];

    // Find the participant whose name matches `user_name`
    const participant = participantsArray?.find(([participantId, participantDetails]) =>
        participantDetails.displayName == props.user_name
    );

    let participantDetails = null;
    if (participant) {
        const [, details] = participant;
        participantDetails = details; // Extract participant details

    }




    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 2;

    useEffect(() => {
        const participantArray = [...participants.keys()];
        const endOffset = dataOffset + dataPerPage;
        setCurrentData(participantArray?.slice(dataOffset, endOffset));
        setPageCount(Math.ceil(participantArray?.length / dataPerPage));
    }, [dataOffset, dataPerPage, participants])

    const handlePageClick = (event) => {
        const newOffset = (event.selected * dataPerPage) % [...participants.keys()].length;
        setDataOffset(newOffset);
        window.scrollTo(0, 0);
    };



    return (
        <div className="bg-dark py-100 video-meet-sec" style={{ minHeight: '100vh' }}>

            {/* <h3>Meeting Id: {props.meetingId}</h3> */}
            {joined === "JOINED" ? (
                <div style={{ padding: '60px', height: '100%' }}>
                    {presenterId ?
                        <>
                            <div className="row p-3">
                                <div className="col-md-9">
                                    <PresenterView presenterId={presenterId} />
                                </div>
                                <div className="col-md-3 row" style={{ overflowY: 'auto', maxHeight: '400px' }}>
                                    {[...participants.keys()]?.map((participantId) => (
                                        <ParticipantViewScreenShare participantId={participantId} key={participantId} />
                                    ))}
                                </div>


                            </div></>
                        :
                        <>
                            {/* 👂 ALL participant audios (no pagination) */}
                            {[...participants.keys()]?.map((participantId) => (
                                <AudioParticipantView participantId={participantId} key={`audio-${participantId}`} />
                            ))}
                            {/* Grid container for participants */}
                            <div className="row p-3" >
                                {currentData?.map((participantId) => (
                                    <ParticipantView participantId={participantId} key={participantId} />
                                ))}

                            </div>

                            {participantsArray?.length > 2 &&
                                <div className="row video-pagination-component" >
                                    <div className="col-lg-12 col-md-12 col-12 text-center d-flex flex-row justify-content-center">
                                        <section className="pagination-section blog-pagination d-flex flex-row justify-content-center">
                                            <nav aria-label="Page navigation" className="nav-class">
                                                <ReactPaginate
                                                    breakLabel="..."
                                                    nextLabel=">"
                                                    onPageChange={handlePageClick}
                                                    pageRangeDisplayed={5}
                                                    pageCount={pageCount}
                                                    previousLabel="<"
                                                    renderOnZeroPageCount={null}
                                                    containerClassName="custom-pagination"
                                                    pageLinkClassName="page-link"
                                                    previousLinkClassName="page-link previous"
                                                    nextLinkClassName="page-link next"
                                                    activeClassName="active-page"
                                                />
                                            </nav>
                                        </section>
                                    </div>

                                </div>}
                        </>
                    }
                    <Controls endTime={props.endTime} meetingId={props.meetingId} user_name={props.user_name} user_type={props.user_type} participantDetails={participantDetails} onMeetingLeave={props?.onMeetingLeave} presenterId={presenterId} location={props?.location} />
                </div>
            ) : joined === "JOINING" ? (
                <WaitingToJoinScreen />
            ) : (

                <div className="d-flex justify-content-center flex-column" style={{ height: '100vh' }}>
                    <h1 className="text-white text-4xl text-center">Meeting is live!</h1>

                    <div className="d-flex justify-content-center align-content-center">
                        <div className="mt-12">
                            <button
                                className="btn btn-light"
                                onClick={joinMeeting}
                            >
                                Join the Meeting
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {
                joined === "REFRESHED" &&
                <div className="d-flex justify-content-center flex-column" style={{ height: '100vh' }}>
                    <h1 className="text-white text-4xl text-center">You left the meeting!</h1>

                    <div className="d-flex justify-content-center align-content-center">
                        <div className="mt-12">
                            <button
                                className="btn btn-light"
                                onClick={joinMeeting}
                            >
                                Rejoin the Meeting
                            </button>
                        </div>
                    </div>
                </div>
            }



        </div>
    );
};

export default MeetingView;
